import { Link } from 'react-router-dom';
import { ScrollReveal } from '@/components/ui/scroll-reveal';

export function PremiumSpaces() {
  return (
    <section className="relative h-[70vh] min-h-[500px] overflow-hidden clip-diag-both">
      <img
        src="/images/heroes/hero-6-skyline-office.webp"
        alt="Premium office skyline"
        className="absolute inset-0 w-full h-full object-cover ken-burns"
      />
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(90deg, rgba(15,15,30,.95) 0%, rgba(15,15,30,.55) 50%, rgba(0,180,216,.3) 100%)',
        }}
      />
      <div className="relative z-10 h-full flex items-center">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 w-full">
          <ScrollReveal direction="left" className="max-w-2xl">
            <div className="text-thunder font-display tracking-[0.4em] text-xs mb-5">// HIGH STAKES · HIGH POLISH</div>
            <h2 className="font-display font-bold text-white text-5xl sm:text-6xl lg:text-8xl leading-[0.9] mb-6">
              PREMIUM SPACES.
              <br />
              <span className="text-electric">PREMIUM CLEAN.</span>
            </h2>
            <p className="text-white/80 text-lg sm:text-xl mb-8 font-light">
              Downtown towers. Executive suites. Client-facing lobbies. The spaces where every detail is inspected — and we pass every time.
            </p>
            <Link
              to="/commercial"
              className="inline-block bg-electric hover:bg-electric-bright text-charcoal-deep font-display font-bold px-8 py-4 tracking-[0.25em] text-sm glow-electric transition"
            >
              COMMERCIAL QUOTE →
            </Link>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
